const loader = () => {
    const loader = document.createElement('div');
    loader.classList.add('loschlegal-loader')

    return loader;
}

export default loader;